<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.71 14.1973C27.8274 14.7078 26.8028 15 25.71 15C22.3963 15 19.71 12.3137 19.71 9C19.71 7.90714 20.0021 6.88252 20.5127 6H4.70996C3.05311 6 1.70996 7.34315 1.70996 9V20C1.70996 21.6569 3.05311 23 4.70996 23H25.71C27.3668 23 28.71 21.6569 28.71 20V14.1973Z"
      fill="#6E6055"
    />
    <rect x="3.70996" y="19" width="23" height="1" fill="white" />
    <rect x="4.70996" y="10" width="9" height="1" fill="white" />
    <rect x="4.70996" y="13" width="12" height="1" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.71 9C20.71 6.24 22.95 4 25.71 4C28.47 4 30.71 6.24 30.71 9C30.71 11.76 28.47 14 25.71 14C22.95 14 20.71 11.76 20.71 9ZM26.31 9.6H28.71V8.4H26.31V6H25.11V8.4H22.71V9.6H25.11V12H26.31V9.6Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  name: "ot-add-card-add",
  props: {
    color: {
      type: String,
      default: "#E10E1C",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
